import React from "react";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { FooterSection, LeadingTitle } from "@components";
import "./Savings.scss";
import { SavingAPI, CreditCardAPI, ShortDescriptionAPI } from "@api";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import HeaderSection from "../../../common/components/Header/HeaderSection";
import LandingCardBox from "../../../common/components/LandingCardBox";
import { TitleComponent } from "../../../common/components/TitleComponent";

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const InvestorContainer = styled.div`
  background-color: #f9f9f9;
  margin-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`;

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`;

const Savings = function () {
  const { t } = useTranslation();
  const [data, setdata] = useState([]);
  const [shortDesc, setShortDesc] = useState({});
  const [isLoading, setisLoading] = useState(false);

  useEffect(() => {
    setisLoading(true);
    loadShortDescData();
  }, []);

  const loadData = async function () {
    const { data } = await SavingAPI("");    
    const grouped = {
      label_tabungan: [],
      label_giro: [],
      label_deposito: [],
      label_lainnya: [],
    };

    data.data.map((item) => {
      let key = "label_lainnya";
      if (
        [1179, 2079, 2080, 2083, 2085, 2086, 2087, 2088, 2089, 2090, 2387].indexOf(
          item.id
        ) > -1
      ) {
        key = "label_tabungan";
      } else if ([2091, 2092].indexOf(item.id) > -1) {
        key = "label_giro";
      } else if ([2093, 2094, 2095, 2098].indexOf(item.id) > -1) {
        key = "label_deposito";
      }

      grouped[key].push(
        <div className="col-lg-4">
          <Desktop>
            <LandingCardBox
              title={item.title}
              image={item.imageBannerDesktop}
              redirectUrl={"/savings/" + item.id}
            />
          </Desktop>
          <Mobile>
            <LandingCardBox
              title={item.title}
              image={item.imageBannerMobile}
              redirectUrl={"/savings/" + item.id}
            />
          </Mobile>
        </div>
      );
    });

    setdata(grouped);    
  };

  const loadShortDescData = async () => {
    const { data } = await ShortDescriptionAPI({ loc: "simpanan" });    
    setShortDesc(data.data ? data.data[0] : "");
    loadData();
    setisLoading(false);    
  };

  return (
    <div>
      <TitleComponent title={shortDesc.title} />
      <Container>
        <HeaderSection
          title={shortDesc.title}
          group={t("solusi_masa_depan_anda")}
          description={shortDesc.description}
          banner={shortDesc.banner}
        />
      </Container>

      <InvestorContainer>
        <div className="p-0 m-0 container-fluid">
          <div className="pt-4 px-3 pb-0">
            <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 flex align-items-center position-relative row">
              <div className="row">
                <div className="col-12">
                  <h4>{t("pilih_jenis_simpanan")}</h4>
                </div>
              </div>
              <div className="mt-2">
                {Object.keys(data).map((group) => {
                  const items = data[group];
                  if (items.length == 0) return false;

                  return (
                    <div className="mb-5">
                      <h5 className="mb-4 section-title">{t(group)}</h5>
                      <div className="row">{items}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </InvestorContainer>
      <FooterSection currentPage={t("simpanan")} />
    </div>
  );
};

export default Savings;
